import modules from '../../../../ManagementApp/wwwroot/client/src/helpers/store/modules';
import apiGens from '../../../../ManagementApp/wwwroot/client/src/helpers/utils/apiHelperGenerators.js';
import defFilters from '../../../../ManagementApp/wwwroot/client/src/helpers/utils/filters.js';
import mixins from '../../../../ManagementApp/wwwroot/client/src/helpers/utils/vueMixins.js';

import notificationsHubModule from '../../../../ManagementApp/wwwroot/client/src/helpers/notificationsHub.js';

import HeaderQuickSearchComp from '../../../../ManagementApp/wwwroot/client/src/containers/HeaderQuickSearch.vue';
import OrderSplitPopupComp from '../../../../ManagementApp/wwwroot/client/src/views/components/OrderSplitPopup.vue';
import BsSelectComp from '../../../../ManagementApp/wwwroot/client/src/views/components/BsSelect.vue';
import BsSelectMultipleComp from '../../../../ManagementApp/wwwroot/client/src/views/components/BsSelectMultiple.vue';
import moneyComp from '../../../../ManagementApp/wwwroot/client/src/views/components/vDecimalInput/index.js';
import OrderCreate from '../../../../ManagementApp/wwwroot/client/src/views/pages/storefronts/orders/Create.vue';
import OrdersImport from '../../../../ManagementApp/wwwroot/client/src/views/pages/storefronts/orders/Import.vue';
import AddressValidationBadgeComp from '../../../../ManagementApp/wwwroot/client/src/views/components/storefronts/orders/AddressValidationBadge.vue';



import OrderDetails from '../../../../ManagementApp/wwwroot/client/src/views/pages/storefronts/orders/View.vue';

import UserGeneratedReportViewComp from '../../../../ManagementApp/wwwroot/client/src/views/pages/reports/generated/View.vue';
import UserGeneratedReportFormComp from '../../../../ManagementApp/wwwroot/client/src/views/pages/reports/generated/Form.vue';
import UserGeneratedReportIndexComp from '../../../../ManagementApp/wwwroot/client/src/views/pages/reports/generated/Index.vue';

import OrderGroupsFormComp from '../../../../ManagementApp/wwwroot/client/src/views/pages/storefronts/orderGroups/Form.vue';
import OrderGroupsListIndexComp from '../../../../ManagementApp/wwwroot/client/src/views/pages/storefronts/orderGroups/Index.vue';
import OrderSourceIntegrationsFormComp from '../../../../ManagementApp/wwwroot/client/src/views/pages/integrations/orderSourceIntegrations/Form.vue';
import OrderSourceIntegrationsListIndexComp from '../../../../ManagementApp/wwwroot/client/src/views/pages/integrations/orderSourceIntegrations/Index.vue';
import StorefrontShipmentsIndexComp from '../../../../ManagementApp/wwwroot/client/src/views/pages/storefronts/shipments/Index.vue';

import AutomationFormPageComp from '../../../../ManagementApp/wwwroot/client/src/views/pages/other/automation/Form.vue';
import AutomationContentFormPageComp from '../../../../ManagementApp/wwwroot/client/src/views/pages/other/automationsContent/Form.vue';

import BulkShipmentDetailsComp from '../../../../ManagementApp/wwwroot/client/src/views/pages/transfers/bulkShipments/View.vue';

//import ImportASN from '../../../../ManagementApp/wwwroot/client/src/views/pages/transfers/purchaseOrders/ImportASN.vue';
//import CreateASN from '../../../../ManagementApp/wwwroot/client/src/views/pages/transfers/purchaseOrders/CreateASN.vue';

import WarehouseItemsByLocationPage from '../../../../ManagementApp/wwwroot/client/src/views/pages/warehouses/warehouseProductLocations/Index.vue';

import WarehouseItemFormPage from '../../../../ManagementApp/wwwroot/client/src/views/pages/warehouses/warehouseItems/WarehouseItemForm.vue';

import POForm from '../../../../ManagementApp/wwwroot/client/src/views/pages/transfers/purchaseOrders/Form.vue';
import ViewShipment from '../../../../ManagementApp/wwwroot/client/src/views/pages/transfers/purchaseOrders/ViewShipment.vue';
import CreateShipmentForm from '../../../../ManagementApp/wwwroot/client/src/views/pages/transfers/purchaseOrders/CreateShipment.vue';
import CreateBulkShipmentPage from '../../../../ManagementApp/wwwroot/client/src/views/pages/transfers/bulkShipments/Form.vue';
import UpdateBulkShipmentPage from '../../../../ManagementApp/wwwroot/client/src/views/pages/transfers/bulkShipments/Update.vue';
import CreateManualShipmentPage from '../../../../ManagementApp/wwwroot/client/src/views/pages/transfers/manualShipments/Form.vue';

import DocsHomePag from '../../../../ManagementApp/wwwroot/client/src/views/pages/other/DocsHome.vue';
import ViewKnowledgeArticlePag from '../../../../ManagementApp/wwwroot/client/src/views/pages/other/ViewKnowledgeArticle.vue';
import ViewKnowledgeGroupPag from '../../../../ManagementApp/wwwroot/client/src/views/pages/other/ViewKnowledgeGroup.vue';

import POView from '../../../../ManagementApp/wwwroot/client/src/views/pages/transfers/purchaseOrders/View.vue';

import POItemsSummaryComp from '../../../../ManagementApp/wwwroot/client/src/views/components/POItemsSummary.vue';

import OrderReturnsPage from '../../../../ManagementApp/wwwroot/client/src/views/pages/storefronts/returns/Index.vue';
import WarehouseItemManageWidgetsComp from '../../../../ManagementApp/wwwroot/client/src/views/components/partials/WarehouseItemManageWidgets.vue';
import InventoryStatusBadgeComp from '../../../../ManagementApp/wwwroot/client/src/views/components/InventoryStatusBadge.vue';
import BulkShipmentsImportSidebarComp from '../../../../ManagementApp/wwwroot/client/src/views/components/BulkShipmentsImportSidebar.vue';
import StorefrontOrdersImportSidebarComp from '../../../../ManagementApp/wwwroot/client/src/views/components/StorefrontOrdersImportSidebar.vue';


import StorefrontIntegrationSystemSelectComp from '../../../../ManagementApp/wwwroot/client/src/views/components/StorefrontIntegrationSystemSelect.vue';
import StorefrontIntegrationSystemConfigCardsComp from '../../../../ManagementApp/wwwroot/client/src/views/components/StorefrontIntegrationSystemConfigCards.vue';

import ProjectIntegrationStatusBadgeComp from '../../../../ManagementApp/wwwroot/client/src/views/components/ProjectIntegrationStatusBadge.vue';
import ProjectIntegrationSystemBadgeComp from '../../../../ManagementApp/wwwroot/client/src/views/components/ProjectIntegrationSystemBadge.vue';

import OrderReturnsFormPage from '../../../../ManagementApp/wwwroot/client/src/views/pages/storefronts/returns/View.vue';
import CommunicationsIndexComp from '../../../../ManagementApp/wwwroot/client/src/views/pages/communications/Index.vue';

import DiscussionsWidgetComponent from '../../../../ManagementApp/wwwroot/client/src/views/components/DiscussionsWidget.vue';

import StorefrontOrderRoutingConfigComp from '../../../../ManagementApp/wwwroot/client/src/views/pages/admin/clients/StorefrontOrderRoutingConfig.vue';

export const StorefrontOrderRoutingConfig = StorefrontOrderRoutingConfigComp;
export const StorefrontIntegrationSystemConfigCards = StorefrontIntegrationSystemConfigCardsComp;
export const StorefrontIntegrationSystemSelect = StorefrontIntegrationSystemSelectComp;
export const WarehouseProductLocationsModule = modules.warehouseProductLocations;
export const OrderGroupsModule = modules.orderGroups;
export const ManageUsersModule = modules.manageUsers;

export const WarehouseProductsModule = modules.warehouseProducts;

export const GeneratedReportsModule = modules.generatedReports;
export const ReturnsModule = modules.returns;
export const OrdersModule = modules.orders;
export const AccountModule = modules.account;
export const GlobalModule = modules.g;
export const ContentTemplatesModule = modules.contentTemplates;
export const AutomationModule = modules.automation;

export const ManualShipmentsModule = modules.manualShipments;
export const BulkShipmentsModule = modules.bulkShipments;
export const ClientShipCodeMappingsModule = modules.clientShipCodeMappings;
export const CustomerInvoicesModule = modules['billing/customerInvoices'];

export const PurchaseOrdersStoreModule = modules.purchaseOrders;
export const WarehouseTransfersStoreModule = modules.warehouseTransfers;
export const AdvancedShipNoticeStoreModule = modules.warehouseShipments;

export const crudMixinGen = mixins.crudMixinGen;
export const apiHelperGenerators = apiGens;
export const filters = defFilters;

export const DocsHome = DocsHomePag;
export const ViewKnowledgeArticle = ViewKnowledgeArticlePag;
export const ViewKnowledgeGroup = ViewKnowledgeGroupPag;

export const POItemsSummary = POItemsSummaryComp;
export const OrderDetailsPage = OrderDetails;
export const BulkShipmentDetailsPage = BulkShipmentDetailsComp;

export const UserGeneratedReportViewPage = UserGeneratedReportViewComp;
export const UserGeneratedReportFormPage = UserGeneratedReportFormComp;
export const UserGeneratedReportIndexPage = UserGeneratedReportIndexComp;

export const OrderGroupsFormPage = OrderGroupsFormComp;
export const OrderGroupsListIndexPage = OrderGroupsListIndexComp;
export const OrderSourceIntegrationsFormPage = OrderSourceIntegrationsFormComp;
export const OrderSourceIntegrationsListIndexPage = OrderSourceIntegrationsListIndexComp;
export const OrderSourceIntegrationsModule = modules.orderSourceIntegrations;

export const AutomationFormPage = AutomationFormPageComp;
export const AutomationContentFormPage = AutomationContentFormPageComp;

export const StorefrontShipmentsIndexPage = StorefrontShipmentsIndexComp;

//export const CreateASNPage = CreateASN;
export const CreateBulkShipmentForm = CreateBulkShipmentPage;
export const UpdateBulkShipmentForm = UpdateBulkShipmentPage;
export const CreateManualShipmentForm = CreateManualShipmentPage;

export const WarehouseItemForm = WarehouseItemFormPage;
//export const ImportASNPage = ImportASN;
export const POFormPage = POForm;
export const ViewShipmentPage = ViewShipment;
export const CreateShipmentFormPage = CreateShipmentForm;

export const POViewPage = POView;

export const OrderReturns = OrderReturnsPage;
export const OrderReturnsForm = OrderReturnsFormPage;

export const myCommonDataMixin = mixins.myCommonDataMixin;
export const OrderCreatePage = OrderCreate;
export const OrdersImportPage = OrdersImport;

export const bsSelect = BsSelectComp;
export const bsSelectMultiple = BsSelectMultipleComp;
export const money = moneyComp;
export const OrderSplitPopup = OrderSplitPopupComp;
export const AddressValidationBadge = AddressValidationBadgeComp;

export const NotificationsHub = notificationsHubModule;
export const HeaderQuickSearch = HeaderQuickSearchComp;

export const WarehouseItemManageWidgets = WarehouseItemManageWidgetsComp;
export const InventoryStatusBadge = InventoryStatusBadgeComp;
export const BulkShipmentsImportSidebar = BulkShipmentsImportSidebarComp;
export const StorefrontOrdersImportSidebar = StorefrontOrdersImportSidebarComp;

export const WarehouseItemsByLocation = WarehouseItemsByLocationPage;
export const DiscussionsWidgetComp = DiscussionsWidgetComponent;
export const CommunicationsIndex = CommunicationsIndexComp;

export const StorefrontShipmentModule = modules['storefrontShipments'];
export const DocsKnowledgebasePagesModule = modules['docs/knowledgebasePages'];
export const DocsKnowledgebaseGroupsModule = modules['docs/knowledgebaseGroups'];
export const DocsChangelogModule = modules['docs/changelog'];

export default {
  CommunicationsIndex: CommunicationsIndexComp,
  DiscussionsWidgetComp: DiscussionsWidgetComponent,

  DocsKnowledgebasePagesModule: modules['docs/knowledgebasePages'],
  DocsKnowledgebaseGroupsModule: modules['docs/knowledgebaseGroups'],
  DocsChangelogModule: modules['docs/changelog'],

  WarehouseItemsByLocation: WarehouseItemsByLocationPage,

  OrderReturns: OrderReturnsPage,
  OrderReturnsForm: OrderReturnsFormPage,

  PurchaseOrdersStoreModule: modules.purchaseOrders,
  WarehouseTransfersStoreModule: modules.warehouseTransfers,
  AdvancedShipNoticeStoreModule: modules.warehouseShipments,

  BulkShipmentsImportSidebar: BulkShipmentsImportSidebarComp,
  StorefrontOrdersImportSidebar: StorefrontOrdersImportSidebarComp,
  InventoryStatusBadge: InventoryStatusBadgeComp,
  WarehouseItemManageWidgets: WarehouseItemManageWidgetsComp,

  NotificationsHub: notificationsHubModule,
  HeaderQuickSearch: HeaderQuickSearchComp,
  OrderSplitPopup: OrderSplitPopupComp,
  AddressValidationBadge: AddressValidationBadgeComp,
  money: moneyComp,
  //CreateASNPage: CreateASN,
  CreateBulkShipmentForm: CreateBulkShipmentPage,
  UpdateBulkShipmentForm: UpdateBulkShipmentPage,
  CreateManualShipmentForm: CreateManualShipmentPage,


  ProjectIntegrationSystemBadge: ProjectIntegrationSystemBadgeComp,
  ProjectIntegrationStatusBadge: ProjectIntegrationStatusBadgeComp,
  StorefrontIntegrationSystemConfigCards: StorefrontIntegrationSystemConfigCardsComp,
  StorefrontIntegrationSystemSelect: StorefrontIntegrationSystemSelectComp,
  //ImportASNPage: ImportASN,

  CreateShipmentFormPage: CreateShipmentForm,
  POFormPage: POForm,
  ViewShipmentPage: ViewShipment,
  POViewPage: POView,
  BulkShipmentDetailsPage: BulkShipmentDetailsComp,
  UserGeneratedReportViewPage: UserGeneratedReportViewComp,
  UserGeneratedReportFormPage: UserGeneratedReportFormComp,
  UserGeneratedReportIndexPage: UserGeneratedReportIndexComp,
  OrderGroupsFormPage: OrderGroupsFormComp,
  OrderGroupsListIndexPage: OrderGroupsListIndexComp,
  OrderSourceIntegrationsFormPage: OrderSourceIntegrationsFormComp,
  OrderSourceIntegrationsListIndexPage: OrderSourceIntegrationsListIndexComp,
  OrderSourceIntegrationsModule: modules.orderSourceIntegrations,
  StorefrontShipmentsIndexPage: StorefrontShipmentsIndexComp,

  AutomationFormPage: AutomationFormPageComp,
  AutomationContentFormPage: AutomationContentFormPageComp,

  DocsHome: DocsHomePag,
  ViewKnowledgeArticle: ViewKnowledgeArticlePag,
  ViewKnowledgeGroup: ViewKnowledgeGroupPag,

  bsSelect: BsSelectComp,
  bsSelectMultiple: BsSelectMultipleComp,
  GeneratedReportsModule: modules.generatedReports,
  ReturnsModule: modules.returns,
  OrdersModule: modules.orders,
  OrderCreatePage: OrderCreate,
  OrdersImportPage: OrdersImport,
  OrderDetailsPage: OrderDetails,
  POItemsSummary: POItemsSummaryComp,
  filters: defFilters,
  AccountModule: modules.account,
  StorefrontShipmentModule: modules.storefrontShipments,
  WarehouseProductsModule: modules.warehouseProducts,
  WarehouseProductLocationsModule: modules.warehouseProductLocations,
  OrderGroupsModule: modules.orderGroups,
  GlobalModule: modules.g,
  contentTemplates: modules.contentTemplates,
  automation: modules.automation,

  ManualShipmentsModule: ManualShipmentsModule,
  BulkShipmentsModule: BulkShipmentsModule,
  ClientShipCodeMappingsModule: modules.clientShipCodeMappings,
  CustomerInvoicesModule: CustomerInvoicesModule,
  crudMixinGen: mixins.crudMixinGen,
  myCommonDataMixin: mixins.myCommonDataMixin,
  mixins: mixins,
  apiHelperGenerators: apiGens
};
